import {useOrganisation} from "hooks/use-organisation";
import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {CaretUpDown as CaretUpDownIcon} from "@phosphor-icons/react/dist/ssr/CaretUpDown";
import {OrganisationContextValue} from "../../../contexts/organisation-context";
import {useUser} from "hooks/use-user";
import {useCallback, useEffect, useState} from "react";
import type Organisation from "benchmarking-domain/organisation";
import useApi from "../../../hooks/use-api";
import Select, {SelectChangeEvent} from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import {InputLabel} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";

export function OrganisationSelector(): React.JSX.Element {
  const [organisations, setOrganisations] = useState<Organisation[]>([]);
  const {subscribeOrganisations} = useApi();

  const { organisationId, setOrganisationId } = useOrganisation();

  useEffect(() => {
    const unsubscribe = subscribeOrganisations(setOrganisations);

    return () => {
      unsubscribe();
    }
  }, [subscribeOrganisations]);

  const handleChange = useCallback((event: SelectChangeEvent) => {
    setOrganisationId(event.target.value);
  }, [setOrganisationId]);

  if (!organisations || organisations.length < 2) {
    return <></>;
  }

  return <Box
    sx={{
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      p: '4px 12px',
    }}
  >
    <FormControl sx={{ flex: '1 1 auto' }}>
      <InputLabel id="organisation" sx={{ background: '#EBECE5' }}>Organisation</InputLabel>
      <Select
        labelId="organisation"
        id="organisation-select"
        value={organisationId}
        onChange={handleChange}
        sx={{ color: "inherit" }}
      >
        {organisations.sort((one, two) => (one.name < two.name ? -1 : 1)).map((organisation) => (
          <MenuItem
            key={organisation.id}
            value={organisation.id}
          >
            {organisation.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
}
